export function isItineraryClientVisible(item) {
  if (!item) return false;
  return item.client_visible !== 0 && item.client_visible !== false;
}

/** Group master and each traveler's copy. A normal trip has neither. */
export function isGroupItineraryTrip(trip) {
  return Boolean(Number(trip?.is_master_trip) || trip?.master_trip_id);
}

/**
 * Shared itinerary on a normal trip: the trip owner and the managing partner
 * both add, edit, and reorder. A group plan stays with the partner.
 */
export function canEditSharedItinerary({ isPartner = false, isCreator = false, trip } = {}) {
  if (isGroupItineraryTrip(trip)) return Boolean(isPartner);
  return Boolean(isPartner || isCreator);
}

export function canManageItineraryDrafts({ isPartner = false, isCreator = false, trip } = {}) {
  if (isPartner) return true;
  if (isGroupItineraryTrip(trip)) return false;
  return Boolean(isCreator);
}

/**
 * On a traveler's copy of a group trip, items from the group's plan
 * (item_source 'shared') are managed by the organizer only.
 */
export function isGroupPlanItem(item) {
  return item?.item_source === 'shared';
}

export function isReadOnlyGroupPlanItem(item, { isPartner = false } = {}) {
  return !isPartner && isGroupPlanItem(item);
}

export function visibleItineraryForViewer(items, viewer) {
  const rows = Array.isArray(items) ? items : [];
  if (canManageItineraryDrafts(viewer)) return rows;
  return rows.filter(isItineraryClientVisible);
}
